export const contactFormData = {
  id: "91-contact-form",
  title: "在线留言",
  description: "如有任何疑问或建议，请填写下方表单，我们会在第一时间与您联系。",
  fields: {
    name: { label: "姓名", type: "text", required: true, placeholder: "请输入您的姓名" },
    email: { label: "邮箱", type: "email", required: true, placeholder: "请输入您的电子邮箱" },
    phone: { label: "电话", type: "tel", required: false, placeholder: "请输入您的联系电话" },
    subject: { label: "主题", type: "text", required: true, placeholder: "请输入留言主题" },
    message: { label: "留言内容", type: "textarea", required: true, placeholder: "请详细描述您的问题或建议（最多500字）", maxLength: 500 },
  },
};